import { useState } from "react";
import TeamMemberModal from "./modal/TeamMemberModal";
import {
  STATIC_TEAM_AGENTS,
  STATIC_TEAM_DIRECTORS,
  STATIC_TEAM_MANAGERS,
  StaticTeamMember,
} from "../../../data/staticSiteContent";
import { Fade } from "react-awesome-reveal";
import { FiMail, FiPhone } from "react-icons/fi";
import { telHrefFromDisplay } from "../../../constants/contact";

const MemberCard = (props: StaticTeamMember) => {
  const [open, setOpen] = useState(false);
  const toggleModal = () => setOpen(!open);
  return (
    <>
      <div className="w-full md:w-1/3 lg:w-1/4 px-3 mb-8">
        <Fade direction="up" triggerOnce>
          <div className="member-card bg-neutral-800 shadow-md text-center py-6 rounded-xl">
            <img
              className="w-28 h-28 rounded-full object-cover-fit mb-4 mx-auto"
              src={
                props.image === "avatar.jpg" ? "/images/avatar.png" : props.image
              }
              alt={props.name}
            />
            <div>
              <h3 className="text-lg mb-2 text-white">{props.name}</h3>
              <p className="text-white text-sm mb-2">
                <span className="font-medium"></span> {props.designation}
              </p>
              <p className="text-gray-300 text-sm mb-3 px-4 leading-relaxed">
                {props.description}
              </p>
              <div className="px-4 space-y-2 mb-4">
                <a
                  href={`mailto:${props.email}`}
                  className="flex items-center justify-center gap-2 text-sm text-white hover:text-cred-100 transition-colors"
                >
                  <FiMail className="text-cred-100 shrink-0" size={18} aria-hidden />
                  <span>{props.email}</span>
                </a>
                <a
                  href={telHrefFromDisplay(props.phone)}
                  className="flex items-center justify-center gap-2 text-sm text-white hover:text-cred-100 transition-colors"
                >
                  <FiPhone className="text-cred-100 shrink-0" size={18} aria-hidden />
                  <span>{props.phone}</span>
                </a>
              </div>
              <button onClick={toggleModal} className="text-cred-100">
                View Profile
              </button>
            </div>
          </div>
        </Fade>
      </div>
      <TeamMemberModal
        title="Profile"
        open={open}
        toggleModal={toggleModal}
        data={props}
      />
    </>
  );
};

const Team = () => {
  const teamDirector = STATIC_TEAM_DIRECTORS;
  const teamManger = STATIC_TEAM_MANAGERS;
  const teamMembers = STATIC_TEAM_AGENTS;

  return (
    <div className="bg-neutral-900 py-16">
      <div className="container mx-auto px-6">
        <>
            {teamDirector.length > 0 && (
              <>
                <h2 className="text-3xl mb-8 text-center text-white">
                  {/*Directors*/}
                  Principal Broker
                </h2>
                <div className="flex flex-wrap justify-center -mx-6">
                  {teamDirector.map((member) => (
                    <MemberCard key={member._id} {...member} />
                  ))}
                </div>
              </>
            )}

            {teamManger.length > 0 && (
              <>
                <h2 className="text-3xl mb-8 text-center text-white">
                  Managers
                </h2>
                <div className="flex flex-wrap justify-center -mx-6">
                  {teamManger.map((member) => (
                    <MemberCard key={member._id} {...member} />
                  ))}
                </div>
              </>
            )}

            {teamMembers.length > 0 && (
              <>
                <h2 className="text-3xl mb-8 text-center text-white">Agents</h2>
                <div className="flex flex-wrap justify-center -mx-6">
                  {teamMembers.map((member) => (
                    <MemberCard key={member._id} {...member} />
                  ))}
                </div>
              </>
            )}

            {teamDirector.length === 0 &&
              teamManger.length === 0 &&
              teamMembers.length === 0 && (
                <p className="text-white text-center">No team members yet.</p>
              )}
        </>
      </div>
    </div>
  );
};

export default Team;
